'use client';

import type { HTMLAttributes } from 'react';
import styled from 'styled-components';

const Sizes = {
  xs: 8,
  sm: 12,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

type IconProps = {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  fill?: string;
};

type Props = {
  icon: string;
} & IconProps &
  HTMLAttributes<HTMLDivElement>;

const IconRenderer = (props: Props) => {
  const { icon, size = 'md', fill = '#9696a0', ...rest } = props;
  return <Icon size={size} fill={fill} {...rest} dangerouslySetInnerHTML={{ __html: icon }} />;
};

export default IconRenderer;

const Icon = styled.div<IconProps>`
  display: flex;

  & > svg {
    width: ${({ size }) => (size ? Sizes[size] : Sizes['md'])}px;
    height: ${({ size }) => (size ? Sizes[size] : Sizes['md'])}px;
    ${({ fill }) => fill && `fill:${fill};`};
  }
`;
